"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var react_laag_1 = require("react-laag");
var Typography_1 = require("../Typography");
var Tooltip = function (_a) {
    var _b, _c;
    var children = _a.children, text = _a.text, show = _a.show, _d = _a.position, position = _d === void 0 ? 'bottom' : _d, backgroundColor = _a.backgroundColor, className = _a.className, textClassName = _a.textClassName, dataTestId = _a["data-testid"];
    var _e = (0, react_laag_1.useHover)(), isOver = _e[0], hoverProps = _e[1];
    var placement = (0, react_1.useMemo)(function () {
        switch (position) {
            case 'top':
                return 'top-center';
            case 'left':
                return 'left-center';
            case 'right':
                return 'right-center';
            case 'bottom':
            default:
                return 'bottom-center';
        }
    }, [position]);
    var _f = (0, react_laag_1.useLayer)({
        isOpen: isOver,
        placement: placement,
        triggerOffset: 10,
    }), triggerProps = _f.triggerProps, _g = _f.layerProps, style = _g.style, layerProps = __rest(_g, ["style"]), arrowProps = _f.arrowProps, renderLayer = _f.renderLayer;
    if (!show || !text || !children) {
        return null;
    }
    var updatedStyle = (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.trim().length) > 0 ? __assign(__assign({}, style), { backgroundColor: backgroundColor }) : style;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-p-1" }, triggerProps, hoverProps, { children: children })), isOver &&
                renderLayer((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": dataTestId, className: (0, classnames_1.default)("\n          tooltip-box\n          squid-p-2  \n          squid-rounded-core-border-radius-sm \n          squid-bg-alias-color-bg-base-inverse \n          squid-w-max\n          squid-max-w-[214px]\n          squid-z-40\n          ", className), style: updatedStyle }, layerProps, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Caption, __assign({ as: "p", color: "on-base-inverse", className: (0, classnames_1.default)('squid-line-height-unset', textClassName) }, { children: text })), (0, jsx_runtime_1.jsx)(react_laag_1.Arrow, __assign({}, arrowProps, { className: "squid-z-40", backgroundColor: (_b = updatedStyle.backgroundColor) !== null && _b !== void 0 ? _b : '#44485A', borderColor: (_c = updatedStyle.backgroundColor) !== null && _c !== void 0 ? _c : '#44485A' }))] })))] }));
};
exports.Tooltip = Tooltip;
